import React from "react";
import { Button, Container } from "react-bootstrap";
import { MdLogin } from "react-icons/md";
import { useSelector } from "react-redux";
import { Route, useNavigate } from "react-router-dom";

const PrivateRoutes = ({ children, ...rest }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();

  return (
isLoggedIn ? children : 
// navigate("?action=login")
<Container className="mainContent text-center">
      <MdLogin size="50px" />
      <h1 className="my-3">Login Required</h1>
      <p>
        You need to login to access this content.{" "}
      </p>
      <Button onClick={() => navigate("/")}>Back to Home</Button>
    </Container>
  );
};

export default PrivateRoutes;
